<div class="card skeleton room-skeleton">
	<div class="card-header loading"></div>
	<div class="card-body">
		<div class="row">
			<div class="col-md-2">
				<h5 class="card-title loading"></h5>
			</div>
		</div>
		<div class="card-img card-img-bottom loading">
			<div class="loader-icon">
				<i class="fas fa-file"></i>
			</div>
		</div>
	</div>
</div>